import { React, useEffect, useState } from 'react';
import HeroSlider from '../Slider/HeroSlider';
import { Link as ScrollLink } from 'react-scroll';
import TextTransition, { presets } from 'react-text-transition';

const Hero5 = ({ data }) => {

  const { sliderImages, title } = data;

  const [index, setIndex] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex(index => index + 1),
      3000, // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

  return (
    <>
      <div className='st-height-b125 st-height-lg-b80' id='home'></div>
      <div id="home" className="st-hero-wrap st-color1 overflow-hidden">
        <div className="st-wave-animation" />
        <div className="st-hero st-style1">
          <div className="container">
            <div className="st-hero-text">
              <h1 className="st-hero-title cd-headline slide">
                We strive in  <br />
                quality for
                <span className="cd-words-wrapper">
                  <TextTransition springConfig={presets.wobbly}>
                    <span className="st-transition-title">
                      {title[index % title.length]}
                    </span>
                  </TextTransition>
                </span>
              </h1>
              <div className="st-hero-subtitle">
                Explore our extensive array of customized home health care services <br/>
                tailored to your specific requirements, aimed at improving your quality of life.
              </div>
              <div className="st-hero-btn">
                <ScrollLink
                  to="contact"
                  className="st-btn st-style1 st-size-medium st-color1 st-smooth-move"
                >
                  Contact Us
                </ScrollLink>
              </div>
            </div>
          </div>
        </div>
        <HeroSlider data={sliderImages} />
      </div>
    </>
  )
}

export default Hero5
